import { State } from '../reducers/rootReducer'
import VehicleCode from '../../entities/VehicleCode'

const vehicleCodeSelector = (state: State): VehicleCode => state.vehicleCode

export default vehicleCodeSelector
